module.exports = __webpack_public_path__ + "static/soc3-22e4fc85b55509ecbcafc4b9582a397f.png";